import { ReactElement, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { useUIV2State } from '~hooks/useUIV2State';
import { PATHS } from '~constants/paths';

import ComponentWithSuspense from '../ComponentWithSuspense';

interface RedirectHomeByEnabledUIV2RouteProps {
  component: ReactNode;
}

const RedirectHomeByEnabledUIV2Route = ({
  component,
}: RedirectHomeByEnabledUIV2RouteProps): ReactElement => {
  const { isEnabledUIV2 } = useUIV2State();

  if (isEnabledUIV2) {
    return <Navigate to={PATHS.HOME.BASE} replace />;
  }

  return <ComponentWithSuspense component={component} />;
};

export default RedirectHomeByEnabledUIV2Route;
